import React, { useMemo } from "react";
import { Chip } from "@mui/material";
import { useGetExerciseSessionQuery } from "@/store/api/user/exerciseApi";
import {
  AnswerReviewDialog,
  normalizeExerciseSession,
} from "@/components/common";

/**
 * ReviewAnswersDialog — thin wrapper for exercise sessions.
 *
 * Public props (UNCHANGED — preserve all existing call sites):
 *   { open, onClose, sessionId }
 *
 * Loads the session via the existing RTK Query endpoint, normalizes the
 * payload into the shared `detailedGroups[]` shape, and renders the unified
 * <AnswerReviewDialog /> from `@/components/common`.
 */
const ReviewAnswersDialog = ({ open, onClose, sessionId }) => {
  const { data: sessionData, isLoading } = useGetExerciseSessionQuery(
    sessionId,
    { skip: !sessionId || !open }
  );

  const session = sessionData?.data;
  const detailedGroups = useMemo(
    () => normalizeExerciseSession(session),
    [session]
  );

  const responses = session?.responses || [];
  const correctCount = responses.filter((r) => r.isCorrect).length;
  const totalCount = responses.length;

  const headerChips =
    totalCount > 0
      ? [
          <Chip
            key="score"
            label={`Score: ${correctCount}/${totalCount}`}
            color={correctCount === totalCount ? "success" : "secondary"}
          />,
        ]
      : [];

  return (
    <AnswerReviewDialog
      open={open}
      onClose={onClose}
      title="Review Your Answers"
      headerChips={headerChips}
      detailedGroups={detailedGroups}
      isLoading={isLoading}
    />
  );
};

export default ReviewAnswersDialog;
